import { getters } from '/@/modules/core/app/helpers/store';
import { PaidPlanRouteConfig } from '@/modules/core/app/helpers/PaidPlanRouteConfig';

export class DocumentRouteConfig extends PaidPlanRouteConfig {
  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    const user = getters.auth.getUser();
    if (user.currentEstate?.isUnPaidSelfServePlan) {
      return true;
    }

    if (user?.currentEstate.isSelfServePlan || user?.currentEstate.isClearWill) {
      return user.permission.canAccessClearWillFileManagementPage;
    }

    return super.canAccessRoute();
  }
}
